// Regex for rules
var integerRegex = /^(0|[1-9][0-9]*)$/;
var stringRegex = /^[A-Za-z0-9][A-Za-z0-9\s]*(?:_[A-Za-z0-9]+)*$/;
var dateRegex = /^(((0[13578]|1[02])\/(0[1-9]|[12]\d|3[01])\/((19|[2-9]\d)\d{2}))|((0[13456789]|1[012])\/(0[1-9]|[12]\d|30)\/((19|[2-9]\d)\d{2}))|(02\/(0[1-9]|1\d|2[0-8])\/((19|[2-9]\d)\d{2}))|(02\/29\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/;
var currencyRegex = /^\$?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[0-9]*)?$/;
var percentageRegex = /^\d+(\.\d{1,2})? %$/;
var decimalRegex = /^((\$?-?)|(-?\$?))([0-9]{1,3},([0-9]{3})*[0-9]{3}|[0-9]+)?(\.[0-9]*)?$/;
var emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
var ssnRegex = /^\d{3}-\d{2}-\d{4}$/;
var zipcodeRegex = /(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$)/;
var phoneRegex = /^((\(\d{3}\) ?)|(\d{3}-))?\d{3}-\d{4}$/; // Common Required Messages
// const REQUIRED_MESSAGE = ' is required.';
// const INVALALID_MESSAGE = ' is not valid.';
// const REQUIRED_NAME = 'Name';
// const REQUIRED_DESCRIPTION = 'Description';
// const REQUIRED_FILENAME = 'Filename';
// const REQUIRED_ZIP_CODE_LOW = 'ZipCode Low';
// const REQUIRED_ZIP_CODE_HIGH = 'ZipCode High';
// const REQUIRED_UNIQUE = ' needs to be unique.';
// const REQUIRED_FIRST_CHOICE = 'First Choice';
// const REQUIRED_SECOND_CHOICE = 'Second Choice';
// const REQUIRED_THIRD_CHOICE = 'Third Choice';
// const REQUIRED_USERNAME = 'User Name';
// const REQUIRED_PASSWORD = 'Password';
// const REQUIRED_IDENTIFIER1 = 'Identifier 1';
// const REQUIRED_IDENTIFIER2 = 'Identifier 2';
// const REQUIRED_ADVERSE_ACTION = 'Adverse Action';
// const REQUIRED_ASSIGN_TO = 'Assign To section';
// const REQUIRED_CONDITION_MET_VALUE = 'Condition Met Value';
// const REQUIRED_CONDITION_NOT_MET_VALUE = 'Condition Not Met Value';
// const REQUIRED_CONDITION = 'Condition';
// const REQUIRED_CREDIT_POLICY_TYPE = 'Credit Policy Type';
// const REQUIRED_X_AXIS = 'X Axis';
// const REQUIRED_Y_AXIS = 'Y Axis';
// const REQUIRED_LENDER_CODE = 'Lender Code';
// const REQUIRED_NOTES = 'Notes';
// const REQUIRED_CITY = 'City';
// const REQUIRED_STATE = 'State';
// const REQUIRED_ZIP = 'Zip';
// const REQUIRED_EMAIL = 'Email';
// Create all validation rules

export var required = function required(value) {
  return value ? undefined : "* Required";
};
export var integer = function integer(value) {
  return value && !integerRegex.test(value) ? "* Must be a number" : undefined;
};
export var string = function string(value) {
  return value && !stringRegex.test(value) ? "* String must start with a letter" : undefined;
};
export var date = function date(value) {
  return value && !dateRegex.test(value) ? "* Please use date format MM/DD/YYYY" : undefined;
};
export var currency = function currency(value) {
  return value && !currencyRegex.test(value) ? "* Must start with a '$'" : undefined;
};
export var percentage = function percentage(value) {
  return value && !percentageRegex.test(value) ? "* Must end with a '%'" : undefined;
};
export var decimal = function decimal(value) {
  return value && !decimalRegex.test(value) ? "* Must be a decimal" : undefined;
};
export var email = function email(value) {
  return value && !emailRegex.test(value) ? "* Invalid email address" : undefined;
};
export var vin = function vin(VIN) {
  var alphaPool = ["", "a", "b", "c", "d", "e", "f", "g", "h", "j", "k", "l", "m", "n", "p", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
  var alphaValue = ["", 1, 2, 3, 4, 5, 6, 7, 8, 1, 2, 3, 4, 5, 7, 9, 2, 3, 4, 5, 6, 7, 8, 9];
  var digitWeight = ["", 8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];
  var finalWeight = [];

  if (/^[a-zA-Z0-9]{17}$/.test(VIN)) {
    var aryVinDigit = [];

    for (var h = 1; h <= 17; h++) {
      aryVinDigit[h] = VIN.substring(h - 1, h);
    }

    var aryVinValue = [];

    for (var i = 1; i <= 17; i++) {
      if (isNaN(aryVinDigit[i])) {
        var goodAlpha = false;

        for (var x = 1; x <= 23; x++) {
          if (aryVinDigit[i] === alphaPool[x]) {
            aryVinValue[i] = alphaValue[x];
            x = 24;
            goodAlpha = true;
          }
        }

        if (!goodAlpha) {
          return false;
        }
      } else {
        aryVinValue[i] = aryVinDigit[i];
      }
    }

    var totalWeight = 0;

    for (var j = 1; j <= 8; j++) {
      finalWeight[j] = aryVinValue[j] * digitWeight[j];
      finalWeight[j + 8] = aryVinValue[j + 9] * digitWeight[j + 9];
      totalWeight = totalWeight + finalWeight[j] + finalWeight[j + 8];
    }

    var checkDigit = totalWeight % 11;

    if (checkDigit === 10) {
      checkDigit = "x";
    }

    if (checkDigit !== aryVinDigit[9]) return false;
    return true;
  } else {
    return false;
  }
};
export var ssn = function ssn(value) {
  return value && !ssnRegex.test(value) ? "* Must use SSN format XXX-XX-XXXX" : undefined;
};
export var zipcode = function zipcode(value) {
  return value && !zipcodeRegex.test(value) ? "* Invalid Zip Code format" : undefined;
};
export var phone = function phone(value) {
  return value && !phoneRegex.test(value) ? "* Invalid Phone format" : undefined;
};
export var composeValidators = function composeValidators() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  console.log(validators);

  if (validators && validators.length === 0) {
    return function (value) {
      return value;
    };
  }

  return function (value) {
    return validators.reduce(function (error, validator) {
      return error || validator(value);
    }, undefined);
  };
};